import React, { useEffect, useState } from "react";
import Filter from "../../../../assets/Icons/filter.png";
import ExcelExport from "../../../../compnenets/commons/xls";
import Modal from "react-responsive-modal";
import Close from "../../../../assets/Images/close.png";
import leftArrow from "../../../../assets/Images/left-arrow.png";
import rightArrow from "../../../../assets/Images/right-arrow.png";
import "../archival.css";
import { PROJECT_ARCHIVAL } from "../../../../services/apiCalls/archivalApiCalls";
import PdfIcon from "../../../../assets/Icons/Pdf_Icon.png";
import DownloadIcon from "../../../../assets/Icons/Download_Icon.png";

export default function JobMethodology({ project }) {
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const [jobMethodologyData, setJobMethodologyData] = useState([]);
  const [filterData, setFilterData] = useState({
    ProjectID: project.project_id,
    StartDate: "",
    EndDate: "",
    DocumentName: "",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalPages = Math.ceil(jobMethodologyData.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = jobMethodologyData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const fetchArchivalMethodology = async (payload) => {
    let obj = payload;
    if (!payload) {
      obj = {
        ProjectID: project.project_id,
      };
    }
    const response = await PROJECT_ARCHIVAL.GetJobMethodologies(obj);
    if (response && response.JobMethodList?.length > 0) {
      setJobMethodologyData(response.JobMethodList);
    } else {
      setJobMethodologyData([]);
    }
  };
  useEffect(() => {
    fetchArchivalMethodology();
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({ ...prev, [name]: value }));
  };
  const downloadFile = (fileUrl) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    console.log(fileUrl?.split("/").pop());
    link.setAttribute("download", fileUrl?.split("/").pop());
    // link.download = decodeURIComponent(fileUrl?.split('/').pop());
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  function truncateFileNameFromPath(fileName, maxLength) {
    const dotIndex = fileName.lastIndexOf(".");
    if (dotIndex === -1) {
      return fileName;
    }

    const name = fileName.substring(0, dotIndex);
    const extension = fileName.substring(dotIndex);

    if (fileName.length > maxLength) {
      const visibleLength = maxLength - 1 - extension.length;
      const startLength = Math.ceil(visibleLength / 2);
      const endLength = Math.floor(visibleLength / 2);
      const truncatedName = `${name.substring(
        0,
        startLength
      )}...${name.substring(name.length - endLength)}`;
      return `${truncatedName}${extension}`;
    }

    return fileName;
  }
  return (
    <React.Fragment>
      <Modal open={open} onClose={() => {}} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Checklist Filter</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => setOpen(false)}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="card mt-0 card-bd-none">
            <div className="card-body">
              <div className="row">
                <div className="col-6">
                  <label className="filter-label">Start date</label>
                  <input
                    type="date"
                    name="StartDate"
                    value={filterData.StartDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">End date</label>
                  <input
                    type="date"
                    name="EndDate"
                    value={filterData.EndDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Document Name</label>
                  <input
                    type="text"
                    name="DocumentName"
                    value={filterData.DocumentName}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center mt-4 pb-4">
          <button
            className="btn btn-primary"
            onClick={() => {
              fetchArchivalMethodology(filterData);
              setOpen(false);
              setCurrentPage(1);
            }}
          >
            Filter
          </button>
        </div>
      </Modal>
      <div className="row">
        <div className="d-flex justify-content-end">
          <div className="download-icon">
            <ExcelExport
              data={jobMethodologyData}
              fileName="Jobmethodology"
              sheet="Jobmethodology List"
            />
          </div>
          <div className="filter-icon mx-2 my-auto">
            <img
              className=""
              onClick={() => {
                setOpen(true);
              }}
              src={Filter}
              width={20}
            />
          </div>
          <div className="my-auto" onClick={() => fetchArchivalMethodology()}>
            <span
              style={{
                cursor: "pointer",
                fontSize: 12,
                fontWeight: 500,
                background: "#8add79f7",
                padding: 5,
                borderRadius: 12,
              }}
            >
              Clear filters
            </span>
          </div>
        </div>
      </div>
      <div className="table-container-archival">
        <table id="custom-table-archival">
          <thead className="table-header-archival">
            <tr>
              <th>Sr No</th>
              <th>Project Name</th>
              <th>Name of document</th>
              <th>Job Methodology</th>
              <th>Created Date</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((row, index) => (
              <tr key={index} onClick={onOpenModal}>
                <td>{index + 1 + (currentPage - 1) * 10}</td>
                <td>{row.ProjectName}</td>
                <td>{row.NameofDocument}</td>
                <td>
                  {row.JobMethodology != "" ? (
                    <>
                      <img
                        src={PdfIcon}
                        alt="PDF Icon"
                        style={{ width: "16px", marginRight: "8px" }}
                      />
                      {truncateFileNameFromPath(
                        decodeURIComponent(
                          row.JobMethodology?.split("/").pop()
                        ),
                        15
                      )}
                      <img
                        src={DownloadIcon}
                        alt="Download Icon"
                        style={{
                          width: "16px",
                          marginLeft: "8px",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          downloadFile(row.JobMethodology);
                        }}
                      />
                    </>
                  ) : (
                    <>-</>
                  )}
                </td>
                <td>{new Date(row?.CreatedOn).toLocaleDateString('en-GB')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        className="pagination"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 15px",
        }}
      >
        <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
          Showing{" "}
          {Math.min(
            (currentPage - 1) * rowsPerPage + 1,
            jobMethodologyData.length
          )}{" "}
          to {Math.min(currentPage * rowsPerPage, jobMethodologyData.length)} of{" "}
          {jobMethodologyData.length} entries
        </div>

        <div
          className="pagination-buttons"
          style={{
            fontSize: "14px",
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            gap: "5px",
          }}
        >
          {/* Left Arrow */}
          <button
            onClick={() => handleClick(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
            style={{
              background: "none",
              border: "none",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
            }}
          >
            <img
              src={leftArrow} // Replace with your actual image path
              alt="Previous"
              height="11px"
              width="7px"
              style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
            />
          </button>

          {/* Page Numbers */}
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              onClick={() => handleClick(i + 1)}
              style={{
                background: currentPage === i + 1 ? "#00B69B" : "transparent",
                color: currentPage === i + 1 ? "#fff" : "#000",
                border: "none",
                borderRadius: "50%",
                width: "30px",
                height: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              {i + 1}
            </button>
          ))}

          {/* Right Arrow */}
          <button
            onClick={() => handleClick(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
            style={{
              background: "none",
              border: "none",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            }}
          >
            <img
              src={rightArrow} // Replace with your actual image path
              alt="Next"
              height="11px"
              width="7px"
              style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}
            />
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}
